import {Pagination as Component} from './components/pagination';
import {usePagination} from './use-pagination';

export const Pagination = Object.assign(Component, {
	usePagination,
});
